import PropTypes from "prop-types";
import {useEffect, useState} from "react";
import {Helmet} from "react-helmet-async";
import {
    Box, Button,
    Card,
    CardContent, CircularProgress,
    Container, FormControlLabel,
    Grid,
    Link,
    Paper,
    Stack, Switch, Table, TableBody, TableCell, TableContainer,
    TableHead,
    TableRow,
    Typography
} from "@mui/material";
import {styled} from "@mui/material/styles";
import {Download, PersonRemove, PrintOutlined} from "@mui/icons-material";
import Scrollbar from "../components/scrollbar";
import {GeneralLayout} from "../layouts/GeneralLayout";
import {useParams} from "react-router-dom";
import {useGetStatementInfoQuery, useGetStatementResultsQuery} from "../store/statement/statementApi";
import PracticeStatementInfoBlock from "../sections/@dashboard/practice/PracticeStatementInfoBlock";
import {
    useAddStudentToPracticeStatementMutation,
    usePracticeStatementResultsQuery,
    useRemoveStudentFromPracticeStatementMutation, useUpdatePracticeStatementGradeMutation
} from "../store/practice/practiceApi";
import MainLayout from "./main";
import PageTitle from "../components/PageTitle";
import IconButton from "@mui/material/IconButton";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import copyObject from "../utils/copyObject";
import FileUploadButton from "../sections/@dashboard/common/FileUploadButton";
import TextField from "@mui/material/TextField";

export default function PracticeStatementResultsPage(props) {
    const {statementId} = useParams();
    const [statementIdentifier, setStatementIdentifier] = useState(statementId);
    const {data, refetch: refetchData} = usePracticeStatementResultsQuery({id: statementIdentifier});
    const [copyOfData, setCopyOfData] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const [adminMode, setAdminMode] = useState(false);
    const [adminChangesAreSaving, setAdminChangesAreSaving] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const roles = localStorage.getItem('roles').split(',');
    const isEmployee = roles.find((item) => item === "employee") !== undefined;
    const [links, setLinks] = useState([]);
    const isAdmin = hasRole('AttNewAdmin');
    const [removeStudentQuery] = useRemoveStudentFromPracticeStatementMutation();
    const [updateStatementGrade] = useUpdatePracticeStatementGradeMutation();
    const [addStudentToPracticeStatement] = useAddStudentToPracticeStatementMutation();
    
    useEffect(() => {
        console.log('useEffect', data)
        if (data === null || data === undefined)
            return;
        // if (copyOfData !== null)
        //     return;
        
        setCopyOfData(copyObject(data));
    }, [data]);

    function hasRole(roleName) {
        return roles.find((item) => item === roleName) !== undefined
    }
    
    function applyVisualChanges() {
        setRefresh(!refresh);
    }

    function getCorrectFsLink(link) {
        // костыль для того, чтобы можно было скачивать файлы из тестового хранилища

        const cachedLink = links.find((item) => item.link === link);
        if (cachedLink !== undefined) {
            console.log('Ссылка найдена в кэше')
            window.open(cachedLink.correctLink, '_blank')
            return;
        }
        console.log('ссылка не найдена в кэше, определяем корректную форму')

        try {
            fetch(link)
                .then((resp) => {
                    console.log('response', resp);
                    if (resp.status === 404) {
                        console.log(`${link} = 404`)
                        links.push({
                            link,
                            correctLink: `${link}?useTest=1`
                        })

                        window.open(`${link}?useTest=1`, '_blank')
                    }
                    else if (resp.status === 200 || resp.status === 300) {
                        links.push({
                            link,
                            correctLink: `${link}`
                        })

                        window.open(`${link}`, '_blank')
                    }
                }).catch((resp) => {
                console.log('error', resp)
                links.push({
                    link,
                    correctLink: `${link}?useTest=1`
                })
            })
        } catch (err) {
            console.log('catch', err)
            console.log(links)
        }
    }

    function handleAdminGradeChange(student, value) {
        student.gradeId = value;
        student.gradeName = getGradeName(value)
        applyVisualChanges();
    }

    async function removeStudent(student) {
        if (!isAdmin)
            return;

        // НЕ УДАЛЯТЬ КОММЕНТАРИЙ НИЖЕ! ЭТО ПРАВИЛО ESLINT
        // eslint-disable-next-line no-restricted-globals
        const agree = confirm(`Вы уверены, что хотите удалить студента ${student.lastName} ${student.firstName} из ведомости?`);
        if (!agree) {
            return;
        }

        setAdminChangesAreSaving(true);

        await removeStudentQuery({
            data: {
                practiceStatementEntryId: student.practiceStatementEntryId
            }
        }).unwrap()
            .then((fulfilled) => {
                if (fulfilled?.success) {
                    setAdminChangesAreSaving(false);
                    student.deleted = true;
                    applyVisualChanges();
                } else {
                    fulfilled.errors.map((item) => {
                        alert(item);
                        return 1;
                    });

                    setAdminChangesAreSaving(false);
                }
            }).catch((reason) => {
                alert("Ошибка");
                setAdminChangesAreSaving(false);
            });
    }
    
    function getGradeName(gradeId) {
        switch (gradeId) {
            case 1:
                return 'Не выставлено';
            case 2:
                return 'Неудовлетворительно';
            case 3:
                return 'Удовлетворительно';
            case 4:
                return 'Хорошо';
            case 5:
                return 'Отлично';
            case 6:
                return 'Не допущен';
            case 7:
                return 'Неявка';
            default:
                return 'Неизвестный тип оценки';
        }
    }

    async function addStudent() {
        setAdminChangesAreSaving(true);
        // const request = {
        //     statementId: data?.statement?.statementId,
        //     studentId: parseInt(selectedStudentToAdd?.key, 10),
        //     gradeId: selectedStudentToAdd?.gradeId
        // }
        //
        // await addStudentToStatement({data: request}).unwrap()
        //     .then((fulfilled) => {
        //         if (fulfilled?.success) {
        //             setAdminChangesAreSaving(false);
        //             alert('Студент успешно добавлен в ведомость. Он появится в списке после перезагрузки страницы')
        //             applyVisualChanges();
        //         } else {
        //             fulfilled.errors.map((item) => {
        //                 alert(item);
        //                 return 1;
        //             });
        //
        //             setAdminChangesAreSaving(false);
        //         }
        //     }).catch((reason) => {
        //         alert("Ошибка");
        //         setAdminChangesAreSaving(false);
        //     });
    }

    function onStudentSelectedToAdd(value) {
        value.gradeId = 1;
        // setSelectedStudentToAdd(value);
    }

    function handleSelectedStudentGradeChange(value) {
        // selectedStudentToAdd.gradeId = value;
        applyVisualChanges();
    }

    async function changeNotAllowed(student) {
        student.notAllowed = !student.notAllowed;

        if (student.notAllowed) {
            student.gradeId = 6;
            student.gradeName = 'Не допущен';
        }
        else {
            student.gradeId = 1;
            student.gradeName = 'Не выставлено';
        }

        setIsSaving(true);

        // await setNotAllowedRequest({data: {
        //         statementGradeId: student.statementGradeId,
        //         value: student.notAllowed
        //     }}).unwrap().then((resp) => {
        //     if (resp?.success) {
        //         console.log('Not allowed flag has been changed successfully')
        //         setIsSaving(false);
        //     } else {
        //         setIsSaving(false);
        //         resp?.errors.map((item) => {
        //             alert(item)
        //             return 1;
        //         });
        //     }
        // }).catch(() => {
        //     alert('Ошибка')
        //     setIsSaving(false);
        // }).finally(() => {
        //     setIsSaving(false);
        // });
    }
    
    function setGradeForStudent(student, gradeId) {
        student.gradeId = parseInt(gradeId, 10);
        student.gradeName = getGradeName(parseInt(gradeId, 10));
    }
    
    async function saveStudentChanges(student) {
        setAdminChangesAreSaving(true);
        await updateStatementGrade({
            data: {
                practiceStatementEntryId: student.practiceStatementEntryId,
                gradeId: student.gradeId,
                attestationListGuid: student.attestationListGuid,
                documentsGuid: student.documentsGuid,
                reportGuid: student.reportGuid,
                registryDocumentId: student.registryDocumentId
            }
        }).unwrap()
            .then((fulfilled) => {
                if (fulfilled?.success) {
                    setAdminChangesAreSaving(false);
                } else {
                    fulfilled.errors.map((item) => {
                        alert(item);
                        return 1;
                    });

                    setAdminChangesAreSaving(false);
                }
            }).catch((reason) => {
                alert("Ошибка");
                setAdminChangesAreSaving(false);
            });
    }
    
    async function addStudentHandler(studentId) {
        setAdminChangesAreSaving(true);
        await addStudentToPracticeStatement({
            data: {
                statementId,
                studentId
            }
        }).unwrap()
            .then((fulfilled) => {
                if (fulfilled?.success) {
                    setAdminChangesAreSaving(false);
                    refetchData();
                    alert('Студент добавлен. Можно приступить к редактированию оценки')
                } else {
                    fulfilled.errors.map((item) => {
                        alert(item);
                        return 1;
                    });

                    setAdminChangesAreSaving(false);
                }
            }).catch((reason) => {
                alert("Ошибка");
                setAdminChangesAreSaving(false);
            });
    }
    
    // async function updateFiles(student) {
    //     setAdminChangesAreSaving(true);
    //     await updateFilesQuery({
    //         data: {
    //             statementId,
    //             studentId: student.studentId,
    //             attestationListGuid: student.attestationListGuid
    //         }
    //     }).unwrap()
    //         .then((fulfilled) => {
    //             if (fulfilled?.success) {
    //                 student.gradeId = parseInt(gradeId, 10);
    //                 student.gradeName = getGradeName(parseInt(gradeId, 10));
    //                 setAdminChangesAreSaving(false);
    //             } else {
    //                 fulfilled.errors.map((item) => {
    //                     alert(item);
    //                     return 1;
    //                 });
    //
    //                 setAdminChangesAreSaving(false);
    //             }
    //         }).catch((reason) => {
    //             alert("Ошибка");
    //             setAdminChangesAreSaving(false);
    //         });
    // }

    function toDateString(date){
        if (date === null || date === undefined)
            return '';

        return new Date(date).toLocaleDateString("ru-RU");
    }

    const content = (<>
        <PageTitle title={`Результаты ведомости по практике`} />

        <Container>
            <Stack
                padding={isEmployee ? "30px 0px 0px 0px" : "100px 0px 0px 100px"}
                direction="column"
                spacing={2}
            >
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        {data === null || data === undefined ? <CircularProgress/> : <></>}
                        Результаты ведомости №{data?.statement?.statementNumber}
                    </Typography>
                    {isAdmin
                        ? <FormControlLabel control={
                            <Switch inputProps={{'aria-label': 'controlled'}}
                                    checked={adminMode}
                                    onChange={(e, check) => setAdminMode(check)}/>
                        } label="Админ"/>
                        : <></>}
                </Stack>

                <PracticeStatementInfoBlock statement={copyOfData?.statement}
                                            addStudentHandler={(id) => addStudentHandler(id)}
                                            printEnabled={copyOfData?.statement?.closingDate !== null}
                                            adminMode={adminMode} />

                <br/>

                <Card>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>#</TableCell>
                                    <TableCell>ФИО студента</TableCell>
                                    <TableCell>Оценка</TableCell>
                                    <TableCell>Аттестационный лист</TableCell>
                                    <TableCell>Отчёт</TableCell>
                                    <TableCell>Документы</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {copyOfData?.statement?.students?.map((student, index) => {
                                    return (
                                        <TableRow>
                                            <TableCell>
                                                <Stack direction={'row'} spacing={1}>
                                                    {adminMode
                                                        ? <IconButton color={'error'}
                                                                      disabled={adminChangesAreSaving}
                                                                      onClick={() => {removeStudent(student)}}
                                                                      size={'small'}><PersonRemove /></IconButton>
                                                        : <></>}
                                                    <Typography fontSize="x-large">{index + 1}</Typography>
                                                </Stack>
                                            </TableCell>
                                            <TableCell>
                                                <Typography>
                                                    {student.deleted
                                                        ? <Typography color={'red'}>Удален</Typography>
                                                        : <></>}
                                                    <strong>{student.lastName}</strong>
                                                    <br />{student.firstName} {student.middleName}
                                                    {student.isFired && (
                                                        <Typography variant="caption" color="error" component="span">
                                                            <br />Отчислен(а)
                                                        </Typography>
                                                    )}
                                                    {student.isAcademicVacation && (
                                                        <Typography variant="caption" color="error" component="span">
                                                            <br />Академический отпуск
                                                        </Typography>
                                                    )}
                                                </Typography>
                                                {adminMode ? <Button size={'small'} onClick={() => {saveStudentChanges(student)}}>Сохранить</Button> : <></>}
                                            </TableCell>
                                            <TableCell>
                                                {adminMode
                                                    ? <Stack spacing={1}>
                                                        <TextField size={'small'}
                                                                fullWidth
                                                                select
                                                                label={'Оценка'}
                                                                onChange={(event) => {setGradeForStudent(student, event.target.value)}}
                                                                defaultValue={student.gradeId} >
                                                            <MenuItem key={1} value={1}>Не выставлено</MenuItem>
                                                            <MenuItem key={2} value={2}>Неудовлетворительно/Не зачтено</MenuItem>
                                                            <MenuItem key={3} value={3}>Удовлетворительно</MenuItem>
                                                            <MenuItem key={4} value={4}>Хорошо</MenuItem>
                                                            <MenuItem key={5} value={5}>Отлично/Зачтено</MenuItem>
                                                            <MenuItem key={6} value={6}>Н/Д</MenuItem>
                                                            <MenuItem key={7} value={7}>Н/Я</MenuItem>
                                                        </TextField>
                                                        
                                                        <TextField size={'small'}
                                                                   fullWidth
                                                                   select
                                                                   label={'Документ по перезачету'}
                                                                   onChange={(event) => {student.registryDocumentId = event.target.value; applyVisualChanges()}}
                                                                   defaultValue={student.registryDocumentId}>
                                                            {student.availableDocuments?.map((doc) => {
                                                                return <MenuItem key={doc.registryDocumentId} value={doc.registryDocumentId}>{doc.documentNumber} от {toDateString(doc.documentDate)}</MenuItem>
                                                            })}
                                                        </TextField>
                                                    </Stack>
                                                    : <Typography
                                                        color={student.gradeId === 2 || student.gradeId === 7 || student.gradeId === 6
                                                            ? 'red'
                                                            : student.gradeId === 3
                                                                ? 'orange'
                                                                : 'green'}>
                                                        {student.gradeName}
                                                    </Typography>}

                                                {student.registryDocumentNumber
                                                    ? <Typography fontSize={'small'}>Перезачтено на основании документа
                                                        <Link onClick={() => {getCorrectFsLink(student.registryDocumentUrl)}}
                                                              style={{'padding': '0px'}}
                                                              size={'small'}> №{student.registryDocumentNumber}</Link>
                                                    </Typography>
                                                    : <></>}
                                            </TableCell>
                                            <TableCell>
                                                {student.attestationList !== null
                                                    ?
                                                    <>
                                                        <Button startIcon={<Download/>}
                                                                href={student.attestationList}
                                                                target={'_blank'}>Просмотреть</Button>
                                                    </>
                                                    : <></>
                                                }

                                                {adminMode
                                                    ? <FileUploadButton existingFileUrl={student.attestationList}
                                                                        maxFileSize={200 * 1024}
                                                                        title={'Администрирование'}
                                                                        uploadingEnabled
                                                                        onFileUploaded={(newUrl, guid) => {
                                                                            student.attestationList = newUrl;
                                                                            student.attestationListGuid = guid;
                                                                            applyVisualChanges();
                                                                        }}
                                                                        onFileDelete={() => {
                                                                            student.attestationList = null;
                                                                            student.attestationListGuid = null;
                                                                            applyVisualChanges();
                                                                        }}/>
                                                    : <></>}
                                            </TableCell>
                                            <TableCell>
                                                {student.report !== null
                                                    ?
                                                    <Button startIcon={<Download/>}
                                                            href={student.report}
                                                            target={'_blank'}>Просмотреть</Button>
                                                    : <></>
                                                }

                                                {adminMode
                                                    ? <FileUploadButton existingFileUrl={student.report}
                                                                        maxFileSize={2 * 1024 * 1024}
                                                                        title={'Администрирование'}
                                                                        uploadingEnabled
                                                                        onFileUploaded={(newUrl, guid) => {
                                                                            student.report = newUrl;
                                                                            student.reportGuid = guid;
                                                                            applyVisualChanges();
                                                                        }}
                                                                        onFileDelete={() => {
                                                                            student.report = null;
                                                                            student.reportGuid = null;
                                                                            applyVisualChanges();
                                                                        }}/>
                                                    : <></>}
                                            </TableCell>
                                            <TableCell>
                                                {student.documents !== null
                                                    ?
                                                    <Button startIcon={<Download/>}
                                                            href={student.documents}
                                                            target={'_blank'}>Просмотреть</Button>
                                                    : <></>
                                                }

                                                {adminMode
                                                    ? <FileUploadButton existingFileUrl={student.documents}
                                                                        maxFileSize={2 * 1024 * 1024}
                                                                        title={'Администрирование'}
                                                                        uploadingEnabled
                                                                        onFileUploaded={(newUrl, guid) => {
                                                                            student.documents = newUrl;
                                                                            student.documentsGuid = guid;
                                                                            applyVisualChanges();
                                                                        }}
                                                                        onFileDelete={() => {
                                                                            student.documents = null;
                                                                            student.documentsGuid = null;
                                                                            applyVisualChanges();
                                                                        }}/>
                                                    : <></>}
                                            </TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Card>

                <Box height={100}/>
            </Stack>
        </Container>
    </>)

    return (
        !isEmployee
            ?
            <GeneralLayout>
                {content}
            </GeneralLayout>
            : <MainLayout>
                {content}
            </MainLayout>
    )
}